import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import {
  SimpleLoading,
  InputHLPure,
  DropDownBtnHLPure,
  SubtitlePageHLPure,
} from "../../pures";
import { ButtonHLPure, DialogSystemGLPure } from "../../pures";
import "./business-administration-address.css";
import { businessIconDefault } from "../../../assets/logos/icons";
import countries from "./countries.js";

const BusinessAdministrationAddressView = ({
  hideShowDetails,
  selectedUser,
  saveStatusForUser,
  token,
  optionsTypeBusiness,
  updateAddress,
  handleChangeImgProfile,
  changeImgFile,
  imgProfileSubtitle,
  uploadFileCustom,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  imageProfile,
  nameComponentUser,
}) => {
  const { t } = useTranslation();
  const [country, setCountry] = useState(
    selectedUser.company.addressCountry || ""
  );
  const [address, setAddress] = useState(
    selectedUser.company.addressStreet || ""
  );
  const [township, setTownship] = useState(
    selectedUser.company.addressTownship || ""
  );
  const [state, setState] = useState(
    selectedUser.company.addressState || ""
  );
  const [zipCode, setZipCode] = useState(
    selectedUser.company.addressZipCode || ""
  );

  const handleChangeCountry = (e) => {
    setCountry(e.target.value);
  };

  const handleChangeAddress = (e) => {
    setAddress(e.target.value);
  };
  const handleChangetownship = (e) => {
    setTownship(e.target.value);
  };

  const handleChangeState = (e) => {
    setState(e.target.value);
  };

  const handleChangePostalCode = (e) => {
    setZipCode(e.target.value);
  };

  const handleSave = () => {
    const body = {
      companyId: selectedUser.companyId,
      addressCountry: country,
      addressStreet: address,
      addressTownship: township,
      addressState: state,
      addressZipCode: zipCode,
    };

    updateAddress(token, body);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationAddNewUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="businessAdministrationAddressView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              t("businessAdministrationPanelView.businessAddress") +
              " " +
              selectedUser.clientName
            }
            informationIcon={false}
            imgProfile={businessIconDefault}
            profileImg={selectedUser?.imgProfile || imageProfile}
            tooltipShow
            openTooltipDescription={false}
            positionTooltip={"bottom"}
            titleTooltip={t("businessAdministrationAddressView.tooltip.img.title")}
            descriptionTooltip={t("businessAdministrationAddressView.tooltip.img.description")}
            altCustomImg={"Empresa"}
            // handleChangeImage={handleChangeImgProfile}
            uploadFile={(e) => uploadFileCustom(e)}
            changeImgFile={changeImgFile}
            justShowImg={false}
          />
        </Grid>
        <Grid
          item
          className="businessAdministrationAddressView-body"
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
        >
          {/*Container primera seccion de items, fila*/}
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationAddressView-form"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="businessAdministrationAddressView-inputs"
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                es={3}
                className="businessAdministrationAddressView-col1"
              >
                {/*Container first second items, col 1*/}

                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  className="businessAdministrationAddressView-dropDownBtnHLPure "
                >
                  <DropDownBtnHLPure
                    labelDropDown={t("businessAdministrationAddressView.country")}
                    optionsDropDown={countries}
                    valueItem={"country"}
                    nameOption={"country"}
                    optionsValue={"México"}
                    onDropDownChange={(e) => handleChangeCountry(e)}
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-buttonHLPure"
                >
                  <InputHLPure
                    labelInput={t("businessAdministrationAddressView.address")}
                    typeInput={"text"}
                    valueInput={address}
                    handleChangeInput={(e) => handleChangeAddress(e)}
                    errorInputText=""
                    informationIcon
                    tooltipShow
                    positionTooltip={"bottom"}
                    titleTooltip={t("businessAdministrationAddressView.address")}
                    descriptionTooltip={t("businessAdministrationAddressView.address.tooltip.description")}
                    inputActive
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-inputHLPure"
                >
                  <InputHLPure
                    labelInput={t("businessAdministrationAddressView.borough.municipality")}
                    typeInput={"text"}
                    valueInput={township}
                    handleChangeInput={(e) => handleChangetownship(e)}
                    errorInputText=""
                    inputActive
                  />
                </Grid>
              </Grid>
              {/*Container second section items, col 2*/}
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="businessAdministrationAddressView-col2"
              >
                <Grid
                  item
                  className="businessAdministrationAddressView-inputHLPure"
                >
                  <InputHLPure
                    labelInput={t("businessAdministrationAddressView.state")}
                    typeInput={"text"}
                    errorInputText=""
                    valueInput={state}
                    handleChangeInput={(e) => handleChangeState(e)}
                    inputActive
                  />
                </Grid>
                <Grid
                  item
                  className="businessAdministrationAddressView-dropDownBtnHLPure"
                >
                  <InputHLPure
                    labelInput={t("businessAdministrationAddressView.cp")}
                    typeInput={"text"}
                    errorInputText=""
                    valueInput={zipCode}
                    handleChangeInput={(e) => handleChangePostalCode(e)}
                    inputActive
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="businessAdministrationAddressView-btnGroup"
          >
            <Grid className="businessAdministrationAddressView-spaceBtns">
              <ButtonHLPure
                primary={false}
                nameBtn={t("button.cancel")}
                onClickBtn={hideShowDetails}
              />
            </Grid>
            <ButtonHLPure primary nameBtn={t("button.save")} onClickBtn={handleSave} />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showWarningRequesting={showWarningRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default BusinessAdministrationAddressView;

